(function () {
  "use strict";

  angular.module("tikonApp").factory("QueryParamsService", QueryParamsService);

  QueryParamsService.$inject = ["$location"];

  function QueryParamsService($location) {
    var filters = {};
    return {
      getFilters: function () {
        filters = angular.copy($location.search());
        return filters;
      },
      updateFilter: function (key, value) {
        filters = this.getFilters();
        filters[key] = value;
        $location.search(filters);
      },
      removeFilter: function (key) {
        filters = this.getFilters();
        delete filters[key];
        $location.search(filters);
      },
      resetFilters: function () {
        filters = {};
        $location.search({});
      },
    };
  }
})();
